import { render, staticRenderFns } from "./DeleteQuestionConfirmationDialog.vue?vue&type=template&id=89f4f510"
import script from "./DeleteQuestionConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./DeleteQuestionConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports